module.exports = __webpack_public_path__ + "img/orderTop.eac99eec.png";